"use client";

import Box from "@mui/material/Box";
import MuiPopper from "@mui/material/Popper";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

import styles from "./Popper.module.scss";
import { PopperProps } from "./PopperProps";

/**
 * 主要用來顯示資訊彈窗，會在 hover 時展示
 */
export default function Popper({
  hoverable,
  content,
  placement = "auto",
  style,
  contentClassName,
}: PopperProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [arrowRef, setArrowRef] = useState(null);

  const hoverHandler = (event: React.MouseEvent<HTMLElement>) => {
    if (event.type === "mouseenter") {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "popper" : undefined;

  return (
    <>
      <div
        className="flex cursor-pointer items-center justify-center"
        aria-describedby={id}
        onMouseEnter={hoverHandler}
        onMouseLeave={hoverHandler}
      >
        {hoverable}
      </div>
      <MuiPopper
        id={id}
        open={open}
        anchorEl={anchorEl}
        className={styles.popper}
        placement={placement}
        modifiers={[
          {
            name: "arrow",
            enabled: true,
            options: {
              element: arrowRef,
            },
          },
          {
            name: "offset",
            enabled: true,
            options: {
              offset: [0, 12],
            },
          },
        ]}
        sx={style}
      >
        <Box
          component="span"
          className={`${styles.arrow} pointer-events-none select-none`}
          ref={setArrowRef}
        />
        <div
          className={twMerge("max-w-[300px] bg-white p-3", contentClassName)}
        >
          {content}
        </div>
      </MuiPopper>
    </>
  );
}
